import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';
import type { EmgAuthClient } from './authClient';

export function useAuth(): AuthContextValue {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuth() called outside <AuthProvider>');
    }
    return ctx;
}

export function useAuthClient(): EmgAuthClient {
    return useAuth().client;
}
